import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function About() {
  const [station, setStation] = useState({
    name: "Radio Rumore Zero",
    tagline: "I Grandi Successi degli Anni 60 70 80 90",
    description:
      "Radio Rumore Zero trasmette 24 ore su 24 i piu grandi successi italiani e internazionali dagli anni Sessanta agli anni Novanta. Quattro decadi di musica indimenticabile, senza pubblicita invadente. Solo musica.",
  });

  useEffect(() => {
    axios.get(`${API}/station`).then((r) => setStation(r.data)).catch(() => {});
  }, []);

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative max-w-6xl mx-auto px-5 sm:px-8 py-20 sm:py-28"
    >
      <div className="grid lg:grid-cols-[1fr_1.2fr] gap-10 lg:gap-16 items-center">
        <div className="relative rounded-2xl overflow-hidden border border-[#332f2b] aspect-[4/5] bg-[#0a0807] flex items-center justify-center">
          <img
            src="/brand/logo-rumore-zero.png"
            alt="Logo Radio Rumore Zero"
            className="w-[78%] h-auto object-contain drop-shadow-[0_0_30px_rgba(255,0,255,0.35)]"
            loading="lazy"
            data-testid="about-logo"
          />
          {/* corner label */}
          <div className="absolute bottom-5 left-5 right-5 z-10">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF6B00]">
              /04 — La stazione
            </div>
          </div>
        </div>

        <div>
          <h2
            data-testid="about-title"
            className="font-anton uppercase text-4xl sm:text-6xl text-[#F5F2EB] leading-none mb-6"
          >
            La nostra <br />
            <span className="text-[#FF6B00]">missione</span>
          </h2>
          <p data-testid="about-description" className="font-mono text-base text-[#A39A8F] leading-relaxed mb-6">
            {station.description}
          </p>

          <div className="grid sm:grid-cols-2 gap-4 mt-8">
            <div className="p-5 rounded-xl border border-[#332f2b] bg-[#1a1816]">
              <div className="font-anton text-4xl text-[#FF6B00]">100%</div>
              <div className="font-mono text-xs uppercase tracking-widest text-[#A39A8F] mt-1">
                Vintage approved
              </div>
            </div>
            <div className="p-5 rounded-xl border border-[#332f2b] bg-[#1a1816]">
              <div className="font-anton text-4xl text-[#FF6B00]">∞</div>
              <div className="font-mono text-xs uppercase tracking-widest text-[#A39A8F] mt-1">
                Nostalgia inclusa
              </div>
            </div>
          </div>

          <div className="mt-8 p-5 rounded-xl border border-[#FF6B00]/30 bg-[#FF6B00]/5">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#FF6B00] mb-2">
              Installa la PWA
            </div>
            <div className="font-oswald uppercase text-lg sm:text-xl text-[#F5F2EB]">
              Aggiungi Rumore Zero alla schermata Home e ascolta ovunque, anche
              in background.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
